import {LANGUAGE_CODES} from '../constants';

const GUIDEBOOKS_SUPPORTED_LANGUAGES: readonly LANGUAGE_CODES[] = [
  LANGUAGE_CODES.en,
  LANGUAGE_CODES.bg,
  LANGUAGE_CODES.ca,
  LANGUAGE_CODES.cs,
  LANGUAGE_CODES.de,
  LANGUAGE_CODES.et,
  LANGUAGE_CODES.fr,
  LANGUAGE_CODES.hu,
  LANGUAGE_CODES.it,
  LANGUAGE_CODES.nl,
  LANGUAGE_CODES.ko,
  LANGUAGE_CODES.pl,
  LANGUAGE_CODES.pt,
  LANGUAGE_CODES.ro,
  LANGUAGE_CODES.ru,
  LANGUAGE_CODES.es,
  LANGUAGE_CODES.uk,
  LANGUAGE_CODES.el,
];

export {GUIDEBOOKS_SUPPORTED_LANGUAGES};
